import type { DateRangeValueType } from '@core/date-range-types';

export enum RelativeUnit {
  Days = 'days',
  Months = 'months',
  Quarters = 'quarters',
  Years = 'years',
}

export interface RelativeUnitOption {
  label: string;
  value: RelativeUnit;
}

export interface DatePickedRelative {
  type: Exclude<
    DateRangeValueType,
    DateRangeValueType.Custom | DateRangeValueType.Range | DateRangeValueType.Exact
  >;
}

export interface DatePickedRange {
  type: DateRangeValueType.Custom | DateRangeValueType.Range;
  min: string;
  max: string;
}

export interface DatePickedExact {
  type: DateRangeValueType.Exact;
  date: string;
}

export interface DatePickerRelativeCustom {
  type: DateRangeValueType.WithinLast | DateRangeValueType.WithinNext;
  value: number;
  unit: `${RelativeUnit}`;
}

export type DatePickerValue = DatePickedRange | DatePickedExact | DatePickerRelativeCustom;
